const ProvasList = () => import("~/components/Views/Prova/Prova/List");
const ProvasNew = () => import("~/components/Views/Prova/Prova/New");

import auth from "~/middleware/auth";
import grupoVerify from "~/middleware/grupoVerify";
import perfilVerify from "~/middleware/perfilVerify";

const breadcrumb = [
  { name: "Integrado", link: "http://on.grupointegrado.br/" },
  { name: "Prova", link: "" },
  { name: "Conteúdo", link: "" }
];

export const prova = [
  {
    path: "conteudo/prova",
    component: ProvasList,
    name: "Prova",
    meta: {
      title: "Prova",
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "conteudo/prova/new",
    component: ProvasNew,
    name: "Nova Prova",
    meta: {
      title: "Nova Prova",
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "conteudo/prova/:id",
    component: ProvasNew,
    name: "Alterar Prova",
    meta: {
      title: "Alterar Prova",
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  }
];



// WEBPACK FOOTER //
// ./src/routes/prova/conteudo/prova.js